import IcSearch from '@/assets/svg/ic-search.svg?inline'
import IcClear from '@/assets/svg/ic-clear.svg?inline'

export default {
  name: 'FiltersSearch',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    acceptableRegExp: {
      type: String // строка типа \d[A-Z] и т.д
    }

  },
  components: {
    IcSearch,
    IcClear
  },
  data() {
    return {
      focused: false
    }
  },
  methods: {
    onInput(event) {
      if (this.acceptableRegExp) {
        const notAcceptRegExp = new RegExp(`[^${this.acceptableRegExp}]`, 'g')
        const processedValue = event.target.value.replace(notAcceptRegExp, '')
        event.target.value = processedValue
        if (processedValue !== this.value) {
          this.$emit('input', processedValue)
        }
        return
      }
      this.$emit('input', event.target.value)
    }
  }
}